import { defineMessages } from 'react-intl';

export default defineMessages({
    buildingAndLocationsTitle: {
        id: "quoteandbind.wizard.commercial.TWIA.BuildingLoc",
        defaultMessage: "Buildings & Locations"
    },
    buildingAndLocationsCardTitle: {
        id: "quoteandbind.wizard.commercial.TWIA.Add buildings and locations by entering their details.",
        defaultMessage: "Add buildings and locations by entering their details."
    },
    addBuilding: {
        id: "quoteandbind.wizard.commercial.TWIA.Add Building",
        defaultMessage: "Add Building"
    },
    cancelButton: {
        id: "quoteandbind.wizard.commercial.TWIA.Cancel",
        defaultMessage: "Cancel"
    },
    nextButton: {
        id: "quoteandbind.wizard.commercial.TWIA.Next",
        defaultMessage: "Next"
    },
    anotherButton: {
        id: "quoteandbind.wizard.commercial.TWIA.anotherBuilding",
        defaultMessage: "Add Another Building"
    },
    doneButton: {
        id: "quoteandbind.wizard.commercial.TWIA.Done",
        defaultMessage: "Done"
    },
    locationStep: {
        id: "quoteandbind.wizard.commercial.TWIA.Location",
        defaultMessage: "Location"
    },
    buildingStep: {
        id: "quoteandbind.wizard.commercial.TWIA.BuildingStep",
        defaultMessage: "Building"
    },
    constructionStep: {
        id: "quoteandbind.wizard.commercial.TWIA.Construction",
        defaultMessage: "Construction"
    },
    coveragesStep: {
        id: "quoteandbind.wizard.commercial.TWIA.Coverages",
        defaultMessage: "Coverages"
    },
    additionalInterestsStep: {
        id: "quoteandbind.wizard.commercial.TWIA.Additional Interests",
        defaultMessage: "Additional Interests"
    },
    cancelModalTitle: {
        id: "quoteandbind.wizard.commercial.TWIA.Cancel Adding Building?",
        defaultMessage: "Cancel Adding Building?"
    },
    cancelModalDescription: {
        id: "quoteandbind.wizard.commercial.TWIA.The information you have already provided about this building will be lost",
        defaultMessage: "The information you have already provided about this building will be lost. Are you sure you want to cancel?"
    },
    previousModalTitle: {
        id: "quoteandbind.wizard.commercial.TWIA.Leave Page?",
        defaultMessage: "Leave Page?"
    },
    previousModalDescription: {
        id: "quoteandbind.wizard.commercial.TWIA.Changes made to the building will be lost. ",
        defaultMessage: "Changes made to the building will be lost."
    },
    editLocation: {
        id: "quoteandbind.wizard.commercial.editLocation",
        defaultMessage: "Edit Location"
    },
    editBuilding: {
        id: "quoteandbind.wizard.commercial.editBuilding",
        defaultMessage: "Edit Building"
    },
    editConstruction: {
        id: "quoteandbind.wizard.commercial.editConstruction",
        defaultMessage: "Edit Construction"
    },
    editCoverages: {
        id: "quoteandbind.wizard.commercial.editCoverages",
        defaultMessage: "Edit Coverages"
    },
    editAddlInt: {
        id: "quoteandbind.wizard.commercial.editAddlInt",
        defaultMessage: "Edit Additional Interest"
    },
})